function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import Decoder from './decoder.js';
import Fetcher from './fetcher.js';
import Player from './player.js';
import Renderer from './renderer.js';
import Timer from './timer.js';
var defaultOptions = {
  waveColor: '#999',
  progressColor: '#555',
  cursorWidth: 1,
  minPxPerSec: 0,
  fillParent: true,
  interact: true,
  autoScroll: true,
  autoCenter: true,
  sampleRate: 8000
};

var WaveSurfer = /*#__PURE__*/function (_Player) {
  _inherits(WaveSurfer, _Player);

  var _super = _createSuper(WaveSurfer);

  /** Create a new WaveSurfer instance */
  function WaveSurfer(options) {
    var _this;

    _classCallCheck(this, WaveSurfer);

    var _a, _b;

    _this = _super.call(this, {
      media: options.media,
      mediaControls: options.mediaControls,
      autoplay: options.autoplay,
      playbackRate: options.audioRate
    });
    _this.plugins = [];
    _this.decodedData = null;
    _this.duration = null;
    _this.subscriptions = [];
    _this.options = Object.assign({}, defaultOptions, options);
    _this.timer = new Timer();
    var audioElement = !options.media ? _this.getMediaElement() : undefined;
    _this.renderer = new Renderer(_this.options, audioElement);

    _this.initPlayerEvents();

    _this.initRendererEvents();

    _this.initTimerEvents();

    _this.initPlugins(); // Load audio if URL is passed or an external media with an src


    var url = _this.options.url || ((_a = _this.options.media) === null || _a === void 0 ? void 0 : _a.currentSrc) || ((_b = _this.options.media) === null || _b === void 0 ? void 0 : _b.src);

    if (url) {
      _this.load(url, _this.options.peaks, _this.options.duration);
    }

    return _this;
  }

  _createClass(WaveSurfer, [{
    key: "initTimerEvents",
    value: function initTimerEvents() {
      var _this2 = this;

      // The timer fires every 16ms for a smooth progress animation
      this.subscriptions.push(this.timer.on('tick', function () {
        var currentTime = _this2.getCurrentTime();

        _this2.renderer.renderProgress(currentTime / _this2.getDuration(), true);

        _this2.emit('timeupdate', currentTime);

        _this2.emit('audioprocess', currentTime);
      }));
    }
  }, {
    key: "initPlayerEvents",
    value: function initPlayerEvents() {
      var _this3 = this;

      this.subscriptions.push(this.onMediaEvent('timeupdate', function () {
        var currentTime = _this3.getCurrentTime();

        _this3.renderer.renderProgress(currentTime / _this3.getDuration(), _this3.isPlaying());

        _this3.emit('timeupdate', currentTime);
      }), this.onMediaEvent('play', function () {
        _this3.emit('play');

        _this3.timer.start();
      }), this.onMediaEvent('pause', function () {
        _this3.emit('pause');

        _this3.timer.stop();
      }), this.onMediaEvent('ended', function () {
        _this3.emit('finish');
      }), this.onMediaEvent('seeking', function () {
        _this3.emit('seeking', _this3.getCurrentTime());
      }));
    }
  }, {
    key: "initRendererEvents",
    value: function initRendererEvents() {
      var _this4 = this;

      this.subscriptions.push( // Seek on click
      this.renderer.on('click', function (relativeX) {
        if (_this4.options.interact) {
          _this4.seekTo(relativeX);

          _this4.emit('interaction', _this4.getCurrentTime());

          _this4.emit('click', relativeX);
        }
      }), // Scroll
      this.renderer.on('scroll', function (startX, endX) {
        var duration = _this4.getDuration();

        _this4.emit('scroll', startX * duration, endX * duration);
      }), // Redraw
      this.renderer.on('render', function () {
        _this4.emit('redraw');
      })); // Drag

      {
        var debounce;
        this.subscriptions.push(this.renderer.on('drag', function (relativeX) {
          if (!_this4.options.interact) return; // Update the visual position

          _this4.renderer.renderProgress(relativeX); // Set the audio position with a debounce


          clearTimeout(debounce);
          debounce = setTimeout(function () {
            _this4.seekTo(relativeX);
          }, _this4.isPlaying() ? 0 : 200);

          _this4.emit('interaction', relativeX * _this4.getDuration());

          _this4.emit('drag', relativeX);
        }));
      }
    }
  }, {
    key: "initPlugins",
    value: function initPlugins() {
      var _this5 = this;

      var _a;

      if (!((_a = this.options.plugins) === null || _a === void 0 ? void 0 : _a.length)) return;
      this.options.plugins.forEach(function (plugin) {
        _this5.registerPlugin(plugin);
      });
    }
    /** Set new wavesurfer options and re-render it */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = Object.assign({}, this.options, options);
      this.renderer.setOptions(this.options);

      if (options.audioRate) {
        this.setPlaybackRate(options.audioRate);
      }

      if (options.mediaControls != null) {
        this.getMediaElement().controls = options.mediaControls;
      }
    }
    /** Register a wavesurfer.js plugin */

  }, {
    key: "registerPlugin",
    value: function registerPlugin(plugin) {
      var _this6 = this;

      plugin.init(this);
      this.plugins.push(plugin); // Unregister plugin on destroy

      this.subscriptions.push(plugin.once('destroy', function () {
        _this6.plugins = _this6.plugins.filter(function (p) {
          return p !== plugin;
        });
      }));
      return plugin;
    }
    /** For plugins only: get the waveform wrapper div */

  }, {
    key: "getWrapper",
    value: function getWrapper() {
      return this.renderer.getWrapper();
    }
    /** Get the current scroll position in pixels */

  }, {
    key: "getScroll",
    value: function getScroll() {
      return this.renderer.getScroll();
    }
    /** Get all registered plugins */

  }, {
    key: "getActivePlugins",
    value: function getActivePlugins() {
      return this.plugins;
    }
  }, {
    key: "loadAudio",
    value: function loadAudio(url, blob, channelData, duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this7 = this;

        var onProgress, arrayBuffer;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.emit('load', url);
                if (this.isPlaying()) this.pause();
                this.decodedData = null;
                this.duration = null; // Fetch the entire audio as a blob if pre-decoded data is not provided

                if (!(!blob && !channelData)) {
                  _context.next = 9;
                  break;
                }

                onProgress = function onProgress(percentage) {
                  return _this7.emit('loading', percentage);
                };

                _context.next = 8;
                return Fetcher.fetchBlob(url, onProgress, this.options.fetchParams);

              case 8:
                blob = _context.sent;

              case 9:
                // Set the mediaelement source
                this.setSrc(url, blob); // Wait for the audio duration
                // It should be a promise to allow event listeners to subscribe to the ready and decode events

                _context.next = 12;
                return Promise.resolve(duration || this.getDuration());

              case 12:
                _context.t1 = _context.sent;

                if (_context.t1) {
                  _context.next = 17;
                  break;
                }

                _context.next = 16;
                return new Promise(function (resolve) {
                  _this7.onceMediaEvent('loadedmetadata', function () {
                    return resolve(_this7.getDuration());
                  });
                });

              case 16:
                _context.t1 = _context.sent;

              case 17:
                _context.t0 = _context.t1;

                if (_context.t0) {
                  _context.next = 22;
                  break;
                }

                _context.next = 21;
                return Promise.resolve(0);

              case 21:
                _context.t0 = _context.sent;

              case 22:
                this.duration = _context.t0;

                if (!channelData) {
                  _context.next = 27;
                  break;
                }

                this.decodedData = Decoder.createBuffer(channelData, this.duration);
                _context.next = 35;
                break;

              case 27:
                if (!blob) {
                  _context.next = 35;
                  break;
                }

                _context.next = 30;
                return blob.arrayBuffer();

              case 30:
                arrayBuffer = _context.sent;
                _context.next = 33;
                return Decoder.decode(arrayBuffer, this.options.sampleRate);

              case 33:
                this.decodedData = _context.sent;

                // Fall back to the decoded data duration if the media duration is incorrect
                if (this.duration === 0 || this.duration === Infinity) {
                  this.duration = this.decodedData.duration;
                }

              case 35:
                this.emit('decode', this.duration); // Render the waveform

                if (this.decodedData) {
                  this.renderer.render(this.decodedData);
                }

                this.emit('ready', this.duration);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /** Load an audio file by URL, with optional pre-decoded audio data */

  }, {
    key: "load",
    value: function load(url, channelData, duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loadAudio(url, undefined, channelData, duration);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /** Load an audio blob */

  }, {
    key: "loadBlob",
    value: function loadBlob(blob, channelData, duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loadAudio('blob', blob, channelData, duration);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /** Zoom the waveform by a given pixels-per-second factor */

  }, {
    key: "zoom",
    value: function zoom(minPxPerSec) {
      if (!this.decodedData) {
        throw new Error('No audio loaded');
      }

      this.renderer.zoom(minPxPerSec);
      this.emit('zoom', minPxPerSec);
    }
    /** Get the decoded audio data */

  }, {
    key: "getDecodedData",
    value: function getDecodedData() {
      return this.decodedData;
    }
    /** Get decoded peaks */

  }, {
    key: "exportPeaks",
    value: function exportPeaks() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$channels = _ref.channels,
          channels = _ref$channels === void 0 ? 1 : _ref$channels,
          _ref$maxLength = _ref.maxLength,
          maxLength = _ref$maxLength === void 0 ? 8000 : _ref$maxLength,
          _ref$precision = _ref.precision,
          precision = _ref$precision === void 0 ? 10000 : _ref$precision;

      if (!this.decodedData) {
        throw new Error('The audio has not been decoded yet');
      }

      var channelsLen = Math.min(channels, this.decodedData.numberOfChannels);
      var peaks = [];

      for (var i = 0; i < channelsLen; i++) {
        var data = this.decodedData.getChannelData(i);
        var length = Math.min(data.length, maxLength);
        var scale = data.length / length;
        var sampledData = [];

        for (var j = 0; j < length; j++) {
          var n = Math.round(j * scale);
          var val = data[n];
          sampledData.push(Math.round(val * precision) / precision);
        }

        peaks.push(sampledData);
      }

      return peaks;
    }
    /** Get the duration of the audio in seconds */

  }, {
    key: "getDuration",
    value: function getDuration() {
      if (this.duration !== null) return this.duration;
      return _get(_getPrototypeOf(WaveSurfer.prototype), "getDuration", this).call(this);
    }
    /** Toggle if the waveform should react to clicks */

  }, {
    key: "toggleInteraction",
    value: function toggleInteraction(isInteractive) {
      this.options.interact = isInteractive;
    }
    /** Seek to a percentage of audio as [0..1] (0 = beginning, 1 = end) */

  }, {
    key: "seekTo",
    value: function seekTo(progress) {
      var time = this.getDuration() * progress;
      this.setTime(time);
    }
    /** Play or pause the audio */

  }, {
    key: "playPause",
    value: function playPause() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.isPlaying() ? this.pause() : this.play());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
    /** Stop the audio and go to the beginning */

  }, {
    key: "stop",
    value: function stop() {
      this.pause();
      this.setTime(0);
    }
    /** Skip N or -N seconds from the current position */

  }, {
    key: "skip",
    value: function skip(seconds) {
      this.setTime(this.getCurrentTime() + seconds);
    }
    /** Empty the waveform by loading a tiny silent audio */

  }, {
    key: "empty",
    value: function empty() {
      this.load('', [[0]], 0.001);
    }
    /** Unmount wavesurfer */

  }, {
    key: "destroy",
    value: function destroy() {
      this.emit('destroy');
      this.plugins.forEach(function (plugin) {
        return plugin.destroy();
      });
      this.subscriptions.forEach(function (unsubscribe) {
        return unsubscribe();
      });
      this.timer.destroy();
      this.renderer.destroy();

      _get(_getPrototypeOf(WaveSurfer.prototype), "destroy", this).call(this);
    }
  }], [{
    key: "create",
    value:
    /** Create a new WaveSurfer instance */
    function create(options) {
      return new WaveSurfer(options);
    }
  }]);

  return WaveSurfer;
}(Player);

export default WaveSurfer;